<script>
    import passportsStore from "../../stores/passportsStore";

    export let value = '';
    export let disabled = false;
</script>

<div class="input-group">
    <span class="input-group-text">{ $passportsStore.prefix }</span>
    <input type="text" class="form-control" bind:value={ value }
           oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
           maxlength="6" on:change  {disabled}>
</div>